













import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import { ENV_MAIN } from '../lib/Constants';
import { useConfig } from '../composables/useConfig';
import SpeedGauge from './SpeedGauge.vue';

export default defineComponent({
    props: {
        fees: {
            type: Array as () => number[],
            required: true,
        },
    },
    setup(props, context) {
        const { config } = useConfig();
        const delay = ref(12); // 2-4h

        watch([() => props.fees, delay], ([fees]) => {
            const availableDelay = Math.min((fees as number[]).length - 1, delay.value);
            let fee = (fees as number[])[availableDelay] || 1;

            // Set minimum fees for each step

            if (config.environment === ENV_MAIN) {
                switch (delay.value) {
                    case 1: fee = Math.max(fee, 20); break;
                    case 12: fee = Math.max(fee, 10); break;
                    default: fee = Math.max(fee, 5); break;
                }
            } else {
                switch (delay.value) {
                    case 1: fee = Math.max(fee, 3); break;
                    case 12: fee = Math.max(fee, 2); break;
                    default: fee = Math.max(fee, 1); break;
                }
            }

            context.emit('fee', fee);
        });

        const speed = computed(() => {
            switch (delay.value) {
                case 1: return 100;
                case 12: return 50;
                default: return 0;
            }
        });

        return {
            delay,
            speed,
        };
    },
    components: {
        SpeedGauge,
    },
});
